import { render, staticRenderFns } from "./UserManagementSetup.vue?vue&type=template&id=48adfae6&scoped=true"
import script from "./UserManagementSetup.vue?vue&type=script&lang=ts"
export * from "./UserManagementSetup.vue?vue&type=script&lang=ts"
import style0 from "./UserManagementSetup.vue?vue&type=style&index=0&id=48adfae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48adfae6",
  null
  
)

export default component.exports